(function($){
    var $fn = $(".comp_tv");

    if($fn.length) {
        var $capacity = $fn.find("[data-capacity]");
        var $slider = $fn.find("[data-slider]");
        var $capacity2 = $fn.find("[data-current-pool]");

        if($capacity2.length) {

            var maxPool = parseInt($capacity2.attr('data-max'));

            setInterval(function () {

                $.ajax({
                    method: 'post',
                    data: {
                        'do': 'updatePool'
                    }
                }).done(function(data) {
                    if(typeof data.pool !== 'undefined') {
                        var currentPool = data.pool;
                        if(currentPool > maxPool) {
                            currentPool = maxPool;
                        }
                        $capacity2.html(currentPool);
                    }
                });
            },15000);
        }

        if($capacity.length) {
            $.getScript("https://cdnjs.cloudflare.com/ajax/libs/progressbar.js/1.0.1/progressbar.min.js").done(function () {
                $capacity.each(function () {
                    var $this = $(this),
                        $max = $this.data("max"),
                        $current = $this.data("capacity"),
                        $radial = $this.find(".elm_radial"),
                        $id = $radial.attr('id'),
                        $bar_color = ($radial.hasClass("mod--red"))?"#f52f59":($radial.hasClass("mod--blue"))?"#009bd9":($radial.hasClass("mod--green"))?"#26a65b":"#ffd400";

                    var bar = new ProgressBar.Circle("#"+$id, {
                        strokeWidth: 6,
                        easing: 'easeInOut',
                        duration: 1500,
                        color: $bar_color,
                        trailColor: '#e6e6e6',
                        trailWidth: 6,
                        svgStyle: null,
                        text: {
                            autoStyleContainer: false
                        },
                        step: function(state, circle) {
                            var value = Math.round(circle.value()*$max);
                            if (value === 0) {
                                circle.setText("<strong>"+0+"</strong>/"+$max);
                            } else {
                                circle.setText("<strong>"+value+"</strong>/"+$max);
                            }
                        }
                    });

                    bar.text.style.fontSize = '2.5em';
                    bar.text.style.color = '#4c4c4c';
                    bar.text.style.fontWeight = '300';

                    animateRadial($current,$max,bar);

                    setInterval(function () {

                        $.ajax({
                            method: 'post',
                            data: {
                                'do': 'updatePool'
                            }
                        }).done(function(data) {
                            if(typeof data.pool !== 'undefined') {
                                animateRadial(data.pool,$max,bar);
                            }
                        });
                    },30000); //interval je pouze pro test, prodlouzit na delsi cas, treba 10 minut (600000)
                });
            });
        }

        if($slider.children().length > 1){
            setTimeout(function () {
                var $autoplay = $slider.data("slider");
                $slider.slick({
                    fade: true,
                    infinite: true,
                    speed: 500,
                    cssEase: 'linear',
                    autoplay: true,
                    autoplaySpeed: $autoplay,
                    arrows: false,
                    dots: true,
                });
            },500);
        }
    }
})(jQuery);